import { CategoryChartQueryFn, CategoryChartQueryParam } from "../categoryChart";
import {
    deltaValue,
    getBaseValue,
    // getKpiReportFromGQResult,
    getValue,
    KpiReport,
    // KpiReport,
    // KpiReportEntity,
    roundValue,
    Unit
} from "../processors";
import { PROVIDER_TITLE_CLASS, SEPARATOR, VALUE_STATUS_NAMING } from "../misc";
import { FigureKpiProviders } from "./categoryChartData.types";
import _ from "lodash";
import { figureDeltaString } from "./figureDeltaString";
import { getKpisForProvidersWithCategoryChart } from "../opendata";

const providerTitleStartEndDiv = {
    providerTitleStartSection: `<div class="${PROVIDER_TITLE_CLASS}">`,
    providerTitleEndSection: `</div>`
};

export const fetchFigureComparisonChartData: CategoryChartQueryFn = async ({
    categoryChart,
    providers,
    kpis,
    category
}: CategoryChartQueryParam): Promise<FigureKpiProviders> => {
    if (
        !categoryChart ||
        !providers ||
        !providers.filter(d => d != null).length ||
        !kpis ||
        !kpis.filter(d => d != null).length
    )
        return null;

    const kpiRepotResults = await getKpisForProvidersWithCategoryChart(kpis, providers, false, categoryChart);

    if (!kpiRepotResults) return null;

    const { displayTitle } = categoryChart;
    const kpiKey = (kpiCode, schemeType) => {
        return _.join([kpiCode ?? "", schemeType ?? ""], SEPARATOR);
    };

    const _kKeyToResults = _.groupBy(kpiRepotResults, d => kpiKey(d.kpiCode, d.schemeType));
    const kKeyToResults: Record<
        string,
        { years: number[]; results: KpiReport[]; tIdToResults: _.Dictionary<KpiReport[]> }
    > = _.keys(_kKeyToResults).reduce((prevValue, currentValue) => {
        const results = _kKeyToResults?.[currentValue] ?? [];
        const providerTIdToResults = _.groupBy(results, d => d?.provider?.tid);
        const years = _.orderBy(_.uniq(results?.map(d => d.year)) ?? [], d => d, "desc");
        prevValue[currentValue] = {
            years,
            results,
            tIdToResults: providerTIdToResults
        };
        return prevValue;
    }, {});

    const figures =
        providers?.map((provider, providerIndex) => {
            // const results = providerTIdToResults[provider?.tid] ?? [];

            // if (!results || !results.length) return null;

            // map each kpi
            return (
                kpis
                    ?.map(kpi => {
                        const kpiCode = kpi[0];
                        const schemeType = kpi[1];
                        const agg = kpi[2] ?? "sum";
                        const figureHeader = kpi[3];
                        const figureFooter = kpi[4];
                        const kKey = kpiKey(kpiCode, schemeType);
                        const { years, tIdToResults } = kKeyToResults?.[kKey] ?? {};
                        const kpiResults = tIdToResults?.[provider?.tid] ?? [];
                        const providerExist = tIdToResults?.[provider?.tid] != null;

                        // const kpiKeyToResults = _.groupBy(results, d => kpiKey(d.kpiCode, d.schemeType));

                        // const kpiResults = kpiKeyToResults[kKey];

                        // if (!kpiResults || !kpiResults.length) return null;

                        // kpiResults should be for one single kpi scheme of a provider across years

                        const latestYear = years?.[0];
                        const previousYear = years?.[1];

                        const latestYearResult = kpiResults.filter(d => latestYear != null && d.year === latestYear);
                        const previousYearResult = kpiResults.filter(
                            d => previousYear != null && d.year === previousYear
                        );

                        const latestYearValues = latestYearResult.filter(d => d?.value != null);
                        const previousYearValues = previousYearResult.filter(d => d?.value != null);

                        const latestYearBaseValues = latestYearValues.map(d => getBaseValue(d.value, d.unit));
                        const previousYearBaseValues = previousYearValues.map(d => getBaseValue(d.value, d.unit));
                        const latestYearBaseUnits = _.uniq(latestYearBaseValues.map(d => d.unit));
                        const previousYearBaseUnits = _.uniq(previousYearBaseValues.map(d => d.unit));

                        // let previousYearUnit: Unit = null;
                        let unit: Unit =
                            latestYearBaseUnits?.length > 1 ||
                            previousYearBaseUnits?.length > 1 ||
                            (latestYearBaseUnits?.length === 1 &&
                                previousYearBaseUnits?.length === 1 &&
                                latestYearBaseUnits?.[0] !== previousYearBaseUnits?.[0])
                                ? null
                                : latestYearBaseUnits[0];

                        let latestYearValue: number = null;
                        let latestYearBaseValue: number = null;
                        let latestYearValueStatus: string = null;
                        let previousYearValue: number = null;
                        let previousYearBaseValue: number = null;
                        // let previousYearValueStatus: string = null;

                        if (agg === "count") {
                            latestYearValue = latestYearValues.length;
                            previousYearValue = latestYearValues.length;
                            latestYearBaseValue = latestYearValue;
                            previousYearBaseValue = previousYearValue;

                            unit = "Count";
                            // previousYearUnit = "Count";
                        } else if (_?.[agg]) {
                            latestYearBaseValue =
                                latestYearBaseValues?.length > 0
                                    ? _?.[`${agg}`](latestYearBaseValues.map(d => d.value))
                                    : null;
                            previousYearBaseValue =
                                previousYearBaseValues?.length > 0
                                    ? _?.[`${agg}`](previousYearBaseValues.map(d => d.value))
                                    : null;

                            // resolve units and values
                            if (latestYearBaseValue != null) {
                                const { unit: tempUnit, value: tempValue1 } = roundValue(latestYearBaseValue, unit);
                                latestYearValue = tempValue1;
                                unit = tempUnit as Unit;
                            } else {
                                latestYearValueStatus = latestYearResult?.[0]?.valueStatus;
                            }

                            if (previousYearBaseValue != null) {
                                const { value: tempValue1 } = roundValue(previousYearBaseValue, unit);
                                previousYearValue = tempValue1;
                                // previousYearUnit = tempUnit as Unit;
                            } else {
                                // previousYearValueStatus = previousYearResult?.[0]?.valueStatus;
                            }
                        }
                        // else {
                        //     latestYearBaseValue =
                        //         latestYearBaseValues?.length > 0 ? _.sum(latestYearBaseValues.map(d => d.value)) : null;
                        //     previousYearBaseValue =
                        //         previousYearBaseValues?.length > 0 ? _.sum(previousYearBaseValues.map(d => d.value)) : null;

                        //     // resolve units and values
                        //     if (latestYearBaseValue != null) {
                        //         const { unit: tempUnit, value: tempValue1 } = roundValue(latestYearBaseValue, unit);
                        //         latestYearValue = tempValue1;
                        //         unit = tempUnit as Unit;
                        //     }

                        //     if (previousYearBaseValue != null) {
                        //         const { value: tempValue1 } = roundValue(previousYearBaseValue, unit);
                        //         previousYearValue = tempValue1;
                        //         // previousYearUnit = tempUnit as Unit;
                        //     }
                        // }

                        // previousYearUnit = "kL";
                        if (!providerExist || latestYearValue == null || unit == null) {
                            // if latest year does not exist
                            const figureHeaderProcessed = _.template(figureHeader ?? "")({
                                ...providerTitleStartEndDiv,
                                year: latestYear,
                                value: null,
                                deltaString: null
                            });

                            const figureFooterProcessed = _.template(figureFooter ?? "")({
                                ...providerTitleStartEndDiv,
                                year: latestYear,
                                value: null,
                                deltaString: null
                            });

                            return {
                                kpiCode,
                                schemeType,
                                unit: null,
                                header:
                                    !figureHeader || figureHeader.toString().trim() === ""
                                        ? null
                                        : {
                                              processed: figureHeaderProcessed,
                                              value: figureHeaderProcessed,
                                              format: figureHeaderProcessed
                                          },

                                footer:
                                    !figureFooter || figureFooter.toString().trim() === ""
                                        ? null
                                        : {
                                              processed: figureFooterProcessed,
                                              value: figureFooterProcessed,
                                              format: figureFooterProcessed
                                          },
                                value:
                                    latestYearValueStatus != null
                                        ? VALUE_STATUS_NAMING?.[latestYearValueStatus] ?? latestYearValueStatus
                                        : !providerExist
                                        ? VALUE_STATUS_NAMING.NR
                                        : previousYearValue != null && latestYearValue == null
                                        ? VALUE_STATUS_NAMING.MD
                                        : VALUE_STATUS_NAMING.NR,
                                decimals: 0
                            };
                        }

                        const delta = deltaValue(previousYearBaseValue, latestYearBaseValue, unit);

                        const deltaString = figureDeltaString(delta, category, providerIndex);
                        const figureHeaderProcessed = _.template(figureHeader ?? "")({
                            ...providerTitleStartEndDiv,
                            year: `${latestYear}`,
                            value: latestYearValue,
                            deltaString
                        });

                        const figureFooterProcessed = _.template(figureFooter ?? "")({
                            ...providerTitleStartEndDiv,
                            year: `${latestYear}`,
                            value: latestYearValue,
                            deltaString
                        });

                        const value = getValue(latestYearValue, unit);
                        const decimals = roundValue(latestYearValue, unit).decimals;

                        return {
                            kpiCode,
                            schemeType,
                            unit: unit,
                            header:
                                !figureHeader || figureHeader.toString().trim() === ""
                                    ? null
                                    : {
                                          processed: figureHeaderProcessed,
                                          value: figureHeaderProcessed,
                                          format: figureHeaderProcessed
                                      },

                            footer:
                                !figureFooter || figureFooter.toString().trim() === ""
                                    ? null
                                    : {
                                          processed: figureFooterProcessed,
                                          value: figureFooterProcessed,
                                          format: figureFooterProcessed
                                      },
                            value,
                            decimals
                        };
                    })
                    ?.filter(d => d != null) ?? []
            );
        }) ?? [];

    // kpi report results for the provider
    const ret: FigureKpiProviders = {
        waterProviders: providers,
        figures,
        title: displayTitle,
        footer: null
    };

    return ret;
};
